// _admin/components/NavbarAdmin.js
import React from 'react';
import { FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useAdminNavbar } from '../_shared/hooks/useAdminNavbar';
import './NavbarAdmin.css';

const NavbarAdmin = ({ 
  adminName = 'Administrador', 
  colors,
  slug,
  isEditable = true 
}) => {
  const {
    telefono,
    newTelefono,
    setNewTelefono,
    isEditing,
    setIsEditing,
    loading,
    error,
    handleSaveTelefono,
    handleLogout
  } = useAdminNavbar(slug);

  return (
    <nav 
      className="navbar-admin"
      style={{
        background: `linear-gradient(90deg, ${colors?.primaryColor || '#3498db'} 33%, ${colors?.secondaryColor || '#2c3e50'} 67%)`,
        color: colors?.textColor || 'white'
      }}
    >
      <div className="navbar-admin-left">
        <img
          src="/images/logox.png"
          alt="InnovateSport Logo"
          className="navbar-admin-logo"
        />
        <span className="navbar-admin-title">InnovateSport</span>
        <span className="navbar-admin-slug">| {slug || 'Cargando...'}</span>
      </div>

      <div className="navbar-admin-center">
        {error && <span className="navbar-admin-error">{error}</span>}
        
        {isEditing ? (
          <div className="navbar-admin-edit-phone">
            <input
              type="text"
              value={newTelefono}
              onChange={(e) => setNewTelefono(e.target.value)}
              placeholder="Número de teléfono"
              className="navbar-admin-phone-input"
            />
            <button 
              onClick={handleSaveTelefono} 
              className="navbar-admin-icon-btn navbar-admin-save-btn"
              title="Guardar"
            >
              <FaSave />
            </button>
            <button 
              onClick={() => {
                setIsEditing(false);
                setNewTelefono(telefono);
              }} 
              className="navbar-admin-icon-btn navbar-admin-cancel-btn"
              title="Cancelar"
            >
              <FaTimes />
            </button>
          </div>
        ) : (
          <a
            href={`https://wa.me/${telefono}`}
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-admin-whatsapp"
            style={{ color: colors?.textColor || 'white' }}
          >
            <FontAwesomeIcon icon={faWhatsapp} className="navbar-admin-whatsapp-icon" />
            <span>{loading ? 'Cargando...' : telefono || 'Sin número'}</span>
          </a>
        )}

        {isEditable && !isEditing && (
          <button 
            onClick={() => setIsEditing(true)} 
            className="navbar-admin-icon-btn navbar-admin-edit-btn"
            title="Editar teléfono"
          >
            <FaEdit />
          </button>
        )}
      </div>

      <div className="navbar-admin-right">
        <span className="navbar-admin-name">{adminName}</span>
        <button 
          className="navbar-admin-logout-btn" 
          onClick={handleLogout}
        >
          Cerrar sesión
        </button>
      </div>
    </nav>
  );
};

export default NavbarAdmin;